
import ViewerAdapter from './ViewerAdapter';
import Container from '@mui/material/Container';

import useGetAuthValues from '../hooks/useGetAuthValues';

export default function CdaViewerPage(): JSX.Element {
  const { user_email, access_token } = useGetAuthValues();

  return (
    <Container maxWidth={false} className="mt-0">
      {user_email && access_token && <ViewerAdapter />}
    </Container>
  );
}
